import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const HwAndServices = React.lazy(async () => ({
    default: (await import('@oc/hw-and-services/module')).HwAndServices
}))

export function HwAndServicesComponent() {
    return <SuspenseWhileLoading LazyComponent={HwAndServices} />
}
